import type { Alert } from "../types";
import type { CheatsheetCtx } from "./types";

/**
 * Turn a firing Alert into a CheatsheetCtx for the drawer. We pull the
 * most useful labels (node, gpu, partition, job id, xid code) so the
 * pre-filled commands are as specific as possible.
 */
export function alertToCtx(a: Alert): CheatsheetCtx {
  const l = a.labels ?? {};
  const gpuLabel = l.gpu; // e.g. "gpu1"
  const gpuIdx =
    gpuLabel && /^gpu(\d+)$/.test(gpuLabel)
      ? Number(gpuLabel.replace("gpu", ""))
      : undefined;
  const gpuId = l.node && gpuLabel ? `${l.node}/${gpuLabel}` : undefined;
  const jobId = l.jobid ? Number(l.jobid) : undefined;
  const xidCode = l.xid ? Number(l.xid) : undefined;
  return {
    card: "alert",
    title: a.name,
    subtitle: a.summary,
    data: {
      alert_name: a.name,
      node: l.node,
      gpu_idx: gpuIdx,
      gpu_id: gpuId,
      partition: l.partition,
      hca: l.hca,
      port: l.port ? Number(l.port) : undefined,
      job_id: jobId,
      xid_code: xidCode,
    },
  };
}
